import type { RefinementListItem } from 'instantsearch.js/es/connectors/refinement-list/connectRefinementList';
import type { MessageDescriptor } from 'react-intl';
import { defineMessages } from 'react-intl';

import { PlayerPlayingStatus } from '@sorare/core/src/__generated__/globalTypes';
import { sortBy } from '@sorare/core/src/lib/arrays';

const playingStatusMessages = defineMessages<PlayerPlayingStatus>({
  [PlayerPlayingStatus.STARTER]: {
    id: 'playingStatus.starter',
    defaultMessage: 'First team',
  },
  [PlayerPlayingStatus.REGULAR]: {
    id: 'playingStatus.injured',
    defaultMessage: 'Squad player',
  },
  [PlayerPlayingStatus.SUPER_SUBSTITUTE]: {
    id: 'playingStatus.superSubstitute',
    defaultMessage: 'Impact player',
  },
  [PlayerPlayingStatus.SUBSTITUTE]: {
    id: 'playingStatus.substitute',
    defaultMessage: 'Bench',
  },
  [PlayerPlayingStatus.NOT_PLAYING]: {
    id: 'playingStatus.reserve',
    defaultMessage: 'Not playing',
  },
  [PlayerPlayingStatus.RETIRED]: {
    id: 'playingStatus.retired',
    defaultMessage: 'Retired',
  },
});

export const formatPlayingStatus = (
  value: string,
  formatMessage: (message: MessageDescriptor) => string
) => {
  const playingStatus = value.toUpperCase() as PlayerPlayingStatus;
  if (playingStatus in playingStatusMessages)
    return formatMessage(playingStatusMessages[playingStatus]);
  return value;
};

const ORDERED_PLAYING_STATUS = [
  PlayerPlayingStatus.STARTER,
  PlayerPlayingStatus.REGULAR,
  PlayerPlayingStatus.SUPER_SUBSTITUTE,
  PlayerPlayingStatus.SUBSTITUTE,
  PlayerPlayingStatus.NOT_PLAYING,
  PlayerPlayingStatus.RETIRED,
];

export const sortPlayingStatus = (items: RefinementListItem[]) =>
  sortBy(
    item => {
      return (ORDERED_PLAYING_STATUS as unknown as string[]).indexOf(
        item.label.toUpperCase()
      );
    },
    [...items]
  );
